import {Component} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {RouterLink} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {IntroductionStudiesComponent} from '../introduction-studies/introduction-studies.component';
import {FaqComponent} from '../faq/faq.component';
import {FooterComponent} from '../footer/footer.component';

@Component({
  selector: 'app-introduction',
  imports: [MatCardModule, MatIconModule, MatButtonModule, RouterLink, IntroductionStudiesComponent, FaqComponent, FooterComponent],
  templateUrl: './introduction.component.html',
  styleUrl: './introduction.component.scss'
})
export class IntroductionComponent {

}
